import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ApiApplications } from './Application';
import { Swagger } from './Swagger';
export const ApiSpecs = ({ record }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(ApiApplications, { id: record.id }),
        React.createElement(Swagger, { id: record.id })));
};
const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightBold,
        padding: theme.spacing(),
        '& .swagger-ui .wrapper': {
            maxWidth: 'unset',
        },
    },
}), {
    name: 'Layer7ApiSpecs',
});
//# sourceMappingURL=ApiSpecs.js.map